import { inject } from 'inversify';
import { Injectable } from '../../decorators/injectable';
import type {
  ClientStatsPreset,
  ClientStatsSeriesResponse,
} from '../consultant/client-stats.service.interface';
import { HttpService, type IHttpService } from '../http/http.service';
import type {
  IMySitesService,
  MySitesAccessResponse,
  MySitesStatsParams,
  MySitesStatsResponse,
} from './my-sites.service.interface';

@Injectable()
export class MySitesService implements IMySitesService {
  constructor(@inject(HttpService) private readonly http: IHttpService) {}

  async getStats(params: MySitesStatsParams): Promise<MySitesStatsResponse> {
    const search = new URLSearchParams();
    search.set('preset', params.preset);
    search.set('page', String(params.page));
    search.set('pageSize', String(params.pageSize));
    const term = params.search?.trim();
    if (term) {
      search.set('search', term);
    }
    if (params.sortBy) {
      search.set('sortBy', params.sortBy);
    }
    if (params.sortOrder) {
      search.set('sortOrder', params.sortOrder);
    }
    return this.http.get<MySitesStatsResponse>(`my-sites/stats?${search.toString()}`);
  }

  async getAccess(): Promise<MySitesAccessResponse> {
    return this.http.get<MySitesAccessResponse>('my-sites/access');
  }

  async getSeries(tenantId: string, preset: ClientStatsPreset): Promise<ClientStatsSeriesResponse> {
    const search = new URLSearchParams();
    search.set('preset', preset);
    return this.http.get<ClientStatsSeriesResponse>(
      `my-sites/${tenantId}/series?${search.toString()}`,
    );
  }
}
